import React, { PropTypes } from 'react'

function Action({text, onClick}) {
  return <div className="kd-action" onClick={onClick}>{text}</div>
}

Action.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default Action



/** WEBPACK FOOTER **
 ** ./client/pages/kitchen-department/Action.js
 **/